export const TEMPLATE_HEADER_MIN_LENGTH = 3;
export const TEMPLATE_HEADER_MAX_LENGTH = 60;
